/**
 * 特集 - 縦割り画像
 * スクロールでパネルが下から順にフェードアップする
 */

const INVIEW_CLASS = "is-inview";
const READY_ATTR = "data-feature-split-images-ready";

/**
 * パネルが画面内に入ったら is-inview を付与する
 */
const observeTargets = (root: Element): void => {
  const targets = root.querySelectorAll("[data-feature-split-panel]");
  if (targets.length === 0) return;

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
    targets.forEach((target) => {
      target.classList.add(INVIEW_CLASS);
    });
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add(INVIEW_CLASS);
        observer.unobserve(entry.target);
      }
    },
    {
      threshold: 0.15,
      rootMargin: "0px 0px -40px 0px",
    },
  );

  targets.forEach((target) => {
    observer.observe(target);
  });
};

/**
 * 未初期化の縦割り画像セクションを初期化する
 */
const initFeatureSplitImages = (): void => {
  const roots = document.querySelectorAll("[data-feature-split-images]");
  roots.forEach((root) => {
    if (root.getAttribute(READY_ATTR) === "true") return;
    root.setAttribute(READY_ATTR, "true");
    observeTargets(root);
  });
};

/**
 * 特集の縦割り画像アニメーションを初期化
 */
export function featureSplitImages(): void {
  initFeatureSplitImages();
  document.addEventListener("shopify:section:load", () => {
    initFeatureSplitImages();
  });
}
